{
  "name": "hestia",
  "version": "1.88.0-staging.14",
  "private": true,
  "description": "Hestia",
  "author": "Daniel COLE <daniel@leggett.fr>",
  "type": "module",
  "scripts": {
    "serve": "vite",
    "build": "export NODE_OPTIONS=--max_old_space_size=4000 && vite build",
    "test": "export NODE_OPTIONS=--max_old_space_size=5000 && vitest run",
    "lint": "eslint --ext .js,.vue .gitignore --format gitlab src",
    "lint:fix": "eslint --ext .js,.vue .gitignore --fix .",
    "e2e:serve": "http-server --proxy http://localhost:3000? ./dist -p 3000 -a localhost -s",
    "e2e:test": "npx playwright test",
    "e2e:test:headed": "npx playwright test --headed",
    "coverage": "vitest run --coverage",
    "e2e:rebuild": "npx playwright test --update-snapshots"
  },
  "dependencies": {
    "@bundled-es-modules/axios": "0.27.2",
    "@guolao/vue-monaco-editor": "1.4.0",
    "@mapbox/mapbox-gl-draw": "1.3.0",
    "@mapbox/mapbox-gl-geocoder": "5.0.1",
    "@pixul/aglaea": "1.1.28-alpha",
    "@pixul/athena": "2.31.2",
    "@pixul/components": "1.0.32",
    "@pixul/dpe": "3.0.0",
    "@pixul/element-ui": "2.14.6",
    "@pixul/hephaestus": "1.35.0-alpha.138",
    "@pixul/hestia-commission": "1.6.1",
    "@pixul/hestia-js-sdk": "1.0.0-staging.1197",
    "@pixul/hestia-node-sdk": "1.0.0-staging.1199",
    "@pixul/hestia-rbac": "2.12.0",
    "@pixul/i18n-nationality": "1.1.2",
    "@pixul/languages": "2.4.1",
    "@pixul/v-mapbox": "1.11.2",
    "@sentry/integrations": "7.114.0",
    "@sentry/tracing": "7.114.0",
    "@sentry/vite-plugin": "2.22.7",
    "@sentry/vue": "8.42.0",
    "@toast-ui/vue-calendar": "1.1.1",
    "@turf/bbox": "6.5.0",
    "@turf/bbox-polygon": "6.5.0",
    "@turf/boolean-point-in-polygon": "6.5.0",
    "@turf/intersect": "6.5.0",
    "@turf/square": "6.5.0",
    "@vue-stripe/vue-stripe": "4.4.4",
    "async-validator": "4.2.5",
    "awesome-phonenumber": "3.1.0",
    "bodybuilder": "2.4.0",
    "chart.js": "3.8.0",
    "chartjs-plugin-datalabels": "2.0.0",
    "core-js": "3.23.3",
    "country-data": "0.0.31",
    "file-loader": "6.2.0",
    "geojson2svg": "2.0.2",
    "gmap-vue": "3.5.4",
    "i18n-iso-countries": "7.5.0",
    "i18n-nationality": "1.3.0",
    "js-cookie": "3.0.1",
    "json-diff-ts": "4.0.1",
    "jspdf": "3.0.1",
    "jspdf-autotable": "5.0.2",
    "jwt-decode": "3.1.2",
    "ky": "0.28.7",
    "libphonenumber-js": "1.10.7",
    "lodash": "4.17.21",
    "lodash.debounce": "4.0.8",
    "lodash.flattendeep": "4.4.0",
    "lodash.get": "4.4.2",
    "lodash.merge": "4.6.2",
    "lodash.omit": "4.5.0",
    "lodash.pick": "4.4.0",
    "lodash.set": "4.3.2",
    "lodash.unionwith": "4.6.0",
    "mapbox-gl": "1.13.2",
    "mapbox-gl-draw-freehand-mode": "2.1.0",
    "mapboxgl-spiderifier": "1.0.10",
    "normalize.css": "8.0.1",
    "nprogress": "0.2.0",
    "p-map": "4.0.0",
    "path-to-regexp": "3.2.0",
    "pdfjs-dist": "2.14.305",
    "posthog-js": "1.250.1",
    "qs": "6.11.1",
    "sortablejs": "1.15.0",
    "tiptap": "1.31.0",
    "tiptap-extensions": "1.35.2",
    "tui-calendar": "1.15.3",
    "ua-parser-js": "1.0.33",
    "vue": "2.7.14",
    "vue-async-computed": "3.9.0",
    "vue-avatar-component": "1.3.1",
    "vue-awesome": "4.3.1",
    "vue-chartjs": "4.1.1",
    "vue-clipboard2": "0.3.3",
    "vue-codemirror": "4.0.6",
    "vue-content-loader": "0.2.3",
    "vue-flag-icon": "2.1.0",
    "vue-fragment": "1.5.1",
    "vue-i18n": "8.27.2",
    "vue-json-pretty": "1.8.3",
    "vue-light-timeline": "1.0.3",
    "vue-loading-overlay": "3.0.0",
    "vue-moment": "4.1.0",
    "vue-my-photos": "1.1.1",
    "vue-pdf": "npm:@pixul/vue-pdf@4.0.5",
    "vue-pdf-embed": "1.1.5",
    "vue-router": "3.5.3",
    "vue-tel-input": "4.4.2",
    "vue2-filters": "0.14.0",
    "vue2-scrollbar": "0.0.3",
    "vuedraggable": "2.24.3",
    "vuex": "3.6.2",
    "vuex-cache": "3.5.0",
    "vuex-persistedstate": "4.1.0"
  },
  "devDependencies": {
    "@babel/core": "7.27.1",
    "@babel/eslint-parser": "7.27.1",
    "@stylistic/eslint-plugin": "4.2.0",
    "@stylistic/eslint-plugin-js": "4.2.0",
    "@hapi/eslint-plugin": "7.0.0",
    "@pixul/hestia-no-id": "4.1.0",
    "@playwright/test": "1.49.1",
    "@semantic-release/changelog": "6.0.1",
    "@semantic-release/git": "10.0.1",
    "@semantic-release/gitlab": "9.3.2",
    "@semantic-release/gitlab-config": "10.0.1",
    "@sentry/webpack-plugin": "1.18.9",
    "@vitejs/plugin-vue2": "2.3.3",
    "@vitest/browser": "3.1.2",
    "@vitest/coverage-v8": "3.1.2",
    "@vitest/ui": "3.1.2",
    "@vue/compiler-sfc": "2.7.14",
    "@vue/test-utils": "1.3.6",
    "eslint": "9.29.0",
    "eslint-formatter-gitlab": "6.0.1",
    "eslint-plugin-align-import": "1.0.0",
    "eslint-plugin-node": "11.1.0",
    "eslint-plugin-promise": "7.2.1",
    "eslint-plugin-vue": "10.2.0",
    "happy-dom": "16.7.2",
    "http-server": "14.1.1",
    "sass": "1.87.0",
    "semantic-release": "19.0.3",
    "semantic-release-slack-bot": "3.5.3",
    "semver": "7.5.2",
    "vite": "8.0.3",
    "vite-plugin-commonjs": "0.10.1",
    "vite-plugin-generate-file": "0.2.0",
    "vitest": "3.1.2"
  },
  "engines": {
    "node": "^18.0.0 || >=20.0.0"
  },
  "importSort": {
    ".vue": {
      "parser": "typescript",
      "style": "eslint",
      "options": {}
    }
  },
  "overrides": {
    "prosemirror-collab": "1.2.2",
    "prosemirror-commands": "1.1.4",
    "prosemirror-dropcursor": "1.3.2",
    "prosemirror-gapcursor": "1.1.5",
    "prosemirror-history": "1.1.3",
    "prosemirror-inputrules": "1.1.3",
    "prosemirror-keymap": "1.1.4",
    "prosemirror-model": "1.13.1",
    "prosemirror-schema-list": "1.1.4",
    "prosemirror-state": "1.3.3",
    "prosemirror-tables": "1.1.1",
    "prosemirror-transform": "1.2.8",
    "prosemirror-utils": "0.9.6",
    "prosemirror-view": "1.16.5",
    "vue-template-compiler": "2.7.14",
    "globals": "15.15.0",
    "node-sass": "9.0.0"
  }
}
